import { concat } from '@/helpers/string';

import type { IAddress } from '@/types/address';

export const agencyName = (name: string, address?: Pick<IAddress, 'city'>) => {
	return concat([name.replace(/\s+$/, ''), address?.city], ' - ');
};
